module.exports = __webpack_public_path__ + "static/media/OfficinaSansITCPro-Bold.f3a8180f.svg";